import type { FC } from 'react'

import { InfoBox } from '@skytech/ui'
import { useQuery } from '@tanstack/react-query'

import queries from '@/app/queries'
import appResources from '@/app/resources'
import Text from '@/app/translations/Text'
import { useLocalDate } from '@/hooks/use-local-date'
import { useLocalDateTime } from '@/hooks/use-local-date-time'

const UserSubmissionDate: FC = () => {
  const { data } = useQuery(queries.form(), appResources.getForm)
  const { formatDate } = useLocalDate()
  const { formatTime } = useLocalDateTime()

  if (!data?.userSubmissionDate) return null

  return (
    <InfoBox emphasis="warning" className="user-submission-date" marginTop={8} marginBottom={-4}>
      <Text
        id="Skjema utfylt {date}"
        date={`${formatDate({ date: data.userSubmissionDate })} - ${formatTime({
          date: data.userSubmissionDate,
          showDate: false,
        })}`}
      />
    </InfoBox>
  )
}

export default UserSubmissionDate
